//Node imports
import { IEvent, delayedCall, dispatcher, ingenuity, killDelayedCall } from "@quest/base-core";
import { FreeGameWinPresentationControllerBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist"
import { SlotEventConstants } from "@quest/slot-core";

//Class imports
import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "../Platform/GameParserModel";
export class FreeGameWinPresentationControllerGame extends FreeGameWinPresentationControllerBehavior {

    /**
    * Method onShowAllFrames override to play symbol anims with stack symbol
    */
    protected onShowAllFrames(): void {
        const windata = (ingenuity.parserModel as GameParserModel).getLinesWinAllUniquePositions();
        if (this.paylineView) {
            dispatcher.fireEvent(SlotEventConstants.FG_SHOW_ALL_FRAMES, {
                callback() {
                    if ((this.model.getIsBigWin())) {
                        dispatcher.fireEvent(SlotEventConstants.FG_SHOW_NEXT_WIN_PRESENTATION);
                    }
                },
                callbackScope: this,
                delayTimer: this.model.getDelayForSpaghttiDispaly(),
                winData: windata
            });
        } else {
            dispatcher.fireEvent(SlotEventConstants.FG_SHOW_NEXT_WIN_PRESENTATION);
        }
        // Play all anim with delay to show stack before static hide.
        if ((ingenuity.parserModel as GameParserModel).getStackSymPresentFG() && (ingenuity.parserModel as GameParserModel).getCommonOffsetsOfStackAndWin().length > 0) {
        delayedCall("playAnimDelayForStack", 100, ()=>{
            killDelayedCall("playAnimDelayForStack");
            dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_ALL_SYMBOL_ANIM);
        }, this)
        }else{
           dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_ALL_SYMBOL_ANIM);
       }
    }
    
    /**overrided to stop feature animations */
    protected onSuspendWinPresentation(): void {
        super.onSuspendWinPresentation();
        dispatcher.fireEvent(eventDispatchers.HIDE_LARGE_STACK_SYMBOL_FG);
        ingenuity.configData.isForceStopDuringPotFG= false;
        ingenuity.configData.stageClickDuringPotConversion = false;
        // !ingenuity.configData.isForceStopDuringPotFG && dispatcher.fireEvent(eventDispatchers.RESET_DATA_FG);
    }

    /**
    * Method onStageClickedFG override to add stage click during pots in FG
    */
    protected  onStageClickedFG(evt?:IEvent) {
        if (ingenuity.configData.stageClickDuringPotConversion) {
            ingenuity.configData.stageClickDuringPotConversion= false;
            dispatcher.fireEvent(eventDispatchers.FORCE_STOP_POT_CONVERSION_FG);
        }
          else if (ingenuity.configData.stageClickOnWinTickup) {
            dispatcher.fireEvent(SlotEventConstantsBehavior.FORCE_STOP_WIN_METER_TICKUP_FG);
        } 
         else {
            super.onStageClickedFG(evt);
        }
    }

}

